module.exports = __webpack_public_path__ + "img/170320.0f5830b8.png";